<div class="ai-tags-panel">
  <div *ngIf="isEmpty" class="ai-tags-panel__empty">
    <i class="pi pi-info-circle"></i>
    <span>
      Not tagged yet. Assets are tagged automatically once a build succeeds on all
      platforms.
    </span>
  </div>

  <ng-container *ngIf="!isEmpty">
    <div *ngIf="warnings.length" class="ai-tags-panel__warnings">
      <i class="pi pi-exclamation-triangle"></i>
      <div>
        <div *ngFor="let warning of warnings">{{ warning }}</div>
      </div>
    </div>

    <div *ngIf="aiTags?.description" class="ai-tags-panel__row">
      <strong>Description</strong>
      <span class="ai-tags-panel__desc">{{ aiTags.description }}</span>
    </div>

    <div *ngIf="objectTags.length" class="ai-tags-panel__row">
      <strong>Objects</strong>
      <div class="ai-tags-panel__pills">
        <span class="pill" *ngFor="let tag of objectTags">{{ tag }}</span>
      </div>
    </div>

    <div *ngIf="attributeGroups.length" class="ai-tags-panel__row">
      <strong>Attributes</strong>
      <div class="ai-tags-panel__groups">
        <div class="ai-tags-panel__group" *ngFor="let group of attributeGroups">
          <span class="ai-tags-panel__group-label">{{ label(group.key) | titlecase }}:</span>
          <span class="pill" *ngFor="let value of group.values">{{ value }}</span>
        </div>
      </div>
    </div>

    <div class="ai-tags-panel__meta">
      <span *ngIf="aiTags?.assetType">{{ label(aiTags.assetType) }}</span>
      <span *ngIf="aiTags?.taggedAt">
        tagged {{ aiTags.taggedAt | date: 'medium' }}
      </span>
    </div>
  </ng-container>
</div>
